import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DirectionsIcon from '@mui/icons-material/Directions';

import { Divider, Paper } from '@mui/material';
import { Button } from '@mui/material';

import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';



const AlumniTable = (props) => {
    return (
        <>
            {props.data ?

                <>

                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow className='bg-warning'>
                                    <TableCell>Enrollment no</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell align="right">Batch</TableCell>
                                    <TableCell align="right">Course</TableCell>
                                    <TableCell align="right">Placed</TableCell>
                                    <TableCell align="right">DOB</TableCell>

                                    {props.handleProcced ?
                                        <TableCell align="right">Action</TableCell>
                                        :
                                        <TableCell align="right">Update</TableCell>
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.data && props.data.map((row) => (
                                    <TableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.enrollment}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.name}
                                        </TableCell>
                                        <TableCell align="right">{row.batch}</TableCell>
                                        <TableCell align="right">{row.course}</TableCell>
                                        <TableCell align="right">{row.placedAt === "undefined" ? '--' : row.placedAt}</TableCell>
                                        <TableCell align="right">{row.dob}</TableCell>

                                        {props.handleProcced ?
                                            <TableCell align="right"><Button onClick={() => props.handleProcced(row)} variant='contained' size='small'><DirectionsIcon />  Proceed</Button></TableCell>
                                            :
                                            <TableCell align="right">
                                                <Button onClick={() => props.handleClickOpen(row)} variant='contained' size='small'><DirectionsIcon />Edit</Button>
                                            </TableCell>
                                        }
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>

                :
                ''


            }
        </>
    )
}

export default AlumniTable;